<template>
    <div class="weekly-plan row">
        <div class="col" v-for="(project, index) in projectArr">
            <div class="m-portlet mt-4">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                KW {{ index }}<span v-if="project.current"> (aktuelle Woche)</span>
                            </h3>
                        </div>
                    </div>
                </div>
                <!--begin::Form-->
                <div class="m-portlet__body">
                    <div>
                        <div>
                            <h5 >Auslastung in Stunden</h5>
                            <div v-if="project.sumHoursToWork > 0" class="row">
                                <div class="col-12 d-flex align-items-center mb-1"><b>{{ project.sumHoursPlanned }}h</b>&nbsp;von&nbsp;<b>{{ project.sumHoursToWork }}h</b>&nbsp;(unterwegs:&nbsp;<b>{{ project.sumHoursOnWay }}h</b>) geplant</div>
                                <div class="col-12 d-flex align-items-center">
                                    <el-progress :color="customColorMoney" :show-text="false" :percentage="project.sumHoursPerc" class="w-100"></el-progress>
                                </div>
                            </div>
                            <h5 class="mt-4">Budget</h5>
                            <div v-if="project.sumMoneyNeed > 0" class="row">
                                <div class="col-12 d-flex align-items-center"><b>{{ project.sumMoney | currency }}</b>&nbsp;von&nbsp;<b>{{ project.sumMoneyNeed | currency }}</b></div>
                                <div class="col-12 d-flex align-items-center">
                                    <el-progress :color="customColorMoney" :show-text="false" :percentage="project.sumMoneyPerc" class="w-100"></el-progress>
                                </div>
                            </div>
                            <hr class="mt-4">
                            <h5>TODO in Stunden</h5>
                            <div v-if="project.sumHoursToWork > 0" class="row">
                                <div class="col-12 d-flex align-items-center mb-1"><b>{{ project.sumHoursToDo }}h</b>&nbsp;von&nbsp;<b>{{ project.sumHoursPlanned }}h</b>&nbsp;Stunden offen</div>
                                <div class="col-12 d-flex align-items-center">
                                    <el-progress :color="customColorMoney" :show-text="false" :percentage="project.sumHoursToDoPerc" class="w-100"></el-progress>
                                </div>
                            </div>
                            <h5 class="mt-4">TODO in Projekten</h5>
                            <div v-if="project.sumHoursToWork > 0" class="row">
                                <div class="col-12 d-flex align-items-center mb-1"><b>{{ project.sumProjectsToPhoto }}</b>&nbsp;von&nbsp;<b>{{ project.sumProjects }}</b>&nbsp;Projekte offen</div>
                                <div class="col-12 d-flex align-items-center">
                                    <el-progress :color="customColorMoney" :show-text="false" :percentage="project.sumProjectsPerc" class="w-100"></el-progress>
                                </div>
                            </div>
                            <h5 class="mt-4">Mitarbeiterauslastung</h5>
                            <div v-for="employee in project.employees" class="row mb-3" v-if="employee.workload > 0">
                                <div class="col-3 d-flex align-items-center">{{ employee.name }}</div>
                                <div class="col-2 d-flex align-items-center">{{ employee.workload }}h</div>
                                <div class="col-5 d-flex align-items-center">
                                    <el-progress :color="customColors" :show-text="false" :percentage="employee.workload / employee.employeeHoursPerWeek * 100" class="w-100"></el-progress>
                                </div>
                                <div class="col-2 d-flex align-items-center">33h</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-portlet__body">
                    <div v-for="projectDetail in project.inquiries">
                        <div class="m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet prio-1" data-portlet="true" >
                            <div class="m-portlet__head pl-2 pr-2 pt-2 pb-2" style="height:auto !important;">
                                <div class="m-portlet__head-caption">
                                    <div>Anfrage - Paket unterwegs</div>
                                </div>
                            </div>
                            <div class="m-portlet__body pl-2 pr-2">
                                <div class="row pt-1 pb-1">
                                    <div class="col-2">
                                        <span v-if="projectDetail.client"><a target="_blank" :href="'/kunde-' + projectDetail.client_id">{{projectDetail.client_id}}</a></span>
                                    </div>
                                    <div class="col-10">
                                        <div v-if="projectDetail.client" class="js-project-portlet__clientName">
                                            <span v-if="projectDetail.client.company">{{projectDetail.client.company }}</span>
                                            <span v-else>{{projectDetail.client.sex_id }} {{projectDetail.client.prename }} {{projectDetail.client.name }}</span>
                                        </div>
                                        <div v-else>
                                            <b><span v-if="projectDetail.firma">{{projectDetail.firma }}</span>
                                            <span v-else>{{ projectDetail.salutation }} {{ projectDetail.pre_name }} {{ projectDetail.name }}</span></b>
                                        </div>
                                        <div class="js-project-portlet__name"><a target="_blank" :href="'/anfrage-' + projectDetail.id">{{ projectDetail.produkttyp }} {{ projectDetail.produkt }}</a></div>
                                        <div class="mb-2 ">
                                            <b>{{ projectDetail.exact_amount }} Bilder in {{projectDetail.working_hours}}h</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="projectDetail in project.projects">
                        <div class="m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet" :class="projectDetail.current_status_id < 6 ? 'prio-2' : 'prio-5'" data-portlet="true">
                            <div class="m-portlet__head pl-2 pr-2 pt-2 pb-2" style="height:auto !important;">
                                <div class="m-portlet__head-caption">
                                    <div v-if="projectDetail.current_status_id >= 6">Projekt - {{projectDetail.status_name}}</div>
                                    <div v-else class="text-primary"><b>Projekt - {{projectDetail.status_name}}</b></div>
                                </div>
                            </div>
                            <div class="m-portlet__body pl-2 pr-2">
                                <div class="row pt-1 pb-1">
                                    <div class="col-2">
                                        <span><a target="_blank" :href="'/kunde-' + projectDetail.client_id">{{projectDetail.client_id}}</a></span>
                                    </div>
                                    <div class="col-10">
                                        <div class="js-project-portlet__clientName mb-2">
                                            <span v-if="projectDetail.client.company">{{projectDetail.client.company }}</span>
                                            <span v-else>{{projectDetail.client.sex_id }} {{projectDetail.client.prename }} {{projectDetail.client.name }}</span>
                                        </div>
                                        <div class="js-project-portlet__name"><a target="_blank" :href="'/projekt-' + projectDetail.id">{{ projectDetail.client_project_count }} - {{ projectDetail.name }}</a></div>
                                        <div class="mb-2">
                                            <b>{{projectDetail.exact_amount}}x Bilder in {{projectDetail.working_hours_calc}}h</b><br />
                                            <b class="text-success">{{projectDetail.sum | currency}}</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6"><i class="fa fa-cog"></i>&nbsp;&nbsp;<span class="js-project-portlet__manager" v-if="projectDetail.manager">{{projectDetail.manager.name}}</span></div>
                                    <div class="col-6"><i class="fa fa-camera"></i>&nbsp;&nbsp;<span class="js-project-portlet__photographer"v-if="projectDetail.photographer">{{projectDetail.photographer.name}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    props: {
        projectArr: Object
    },
    data(){
        return{
            customColors: [
                {color: '#5cb87a', percentage: 20},
                {color: '#e6a23c', percentage: 50},
                {color: '#e6a23c', percentage: 60},
                {color: '#f56c6c', percentage: 90},
                {color: '#f56c6c', percentage: 100}
            ],
            customColorMoney: [
                {color: '#f56c6c', percentage: 20},
                {color: '#f56c6c', percentage: 50},
                {color: '#e6a23c', percentage: 60},
                {color: '#5cb87a', percentage: 90},
                {color: '#5cb87a', percentage: 100}
            ],
        }
    }
}
</script>
